import React from 'react';
import { HeroSection } from './HeroSection';
import { TruthSection } from './TruthSection';
import { EmpathySection } from './EmpathySection';
import { ProductIntro } from './ProductIntro';
import { RealExample } from './RealExample';
import { WhyWomenDont } from './WhyWomenDont';
import { SavingsSection } from './SavingsSection';
import { ComparisonSection } from './ComparisonSection';
import { QualifierSection } from './QualifierSection';
import { FinalCTA } from './FinalCTA';
import { FAQSection } from './FAQSection';
import { Footer } from './Footer';
import { SocialProofNotification } from './SocialProofNotification';
import { FloatingCTA } from './FloatingCTA';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-cream-50" data-id="element-233">
      <HeroSection data-id="element-234" />
      <TruthSection data-id="element-235" />
      <EmpathySection data-id="element-236" />
      <ProductIntro data-id="element-237" />
      <RealExample data-id="element-238" />
      <WhyWomenDont data-id="element-239" />
      <SavingsSection data-id="element-240" />
      <FinalCTA data-id="element-241" />
      <FAQSection data-id="element-242" />
      <Footer data-id="element-243" />
      <SocialProofNotification data-id="element-244" />
      <FloatingCTA data-id="element-245" />
    </main>;
}